import type { ReactNode } from 'react';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/uk';

type DatePickerProviderProps = {
  children: ReactNode;
};

export const DatePickerProvider = (props: DatePickerProviderProps) => {
  const { children } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="uk">
      {children}
    </LocalizationProvider>
  );
};
